window.gMapCallback = function() {

    const container = document.querySelector("[data-map]"),
        hidden = container.getAttribute("data-hidden") || false,
        toggle = document.querySelector(container.getAttribute("data-toggle") || null);

    if(hidden) {

        toggle.addEventListener("click",function (event) {
            initMap(container);
            event.preventDefault();
        },{once: true});

        return;
    }

    initMap(container);
}

const initMap = function(node) {

    const zoom = parseInt(node.getAttribute("data-zoom")),
        marker = {
            lat: parseFloat(node.getAttribute("data-marker-lat")),
            lng: parseFloat(node.getAttribute("data-marker-lng"))
        };

    const map = new google.maps.Map(node, {
        scrollwheel: false,
        zoom: zoom,
        center: marker
    });

    new google.maps.Marker({
        map: map,
        position: marker
    });

    google.maps.event.addListenerOnce(map, 'idle', () => {
        document.getElementsByTagName('iframe')[0].title = "Google Maps";
    })

};